<script setup>
/*
    LED widget

    Components:
        primary: <div>

    Widget Properties:
        value: [bool, bool, bool, ...]

    Component Args

    CSS Properties:
 */
import {reactive, ref} from 'vue'
import {getWidgetProps} from '@/paks/vu-dash/BoardUtils'

defineExpose({update})

const props = defineProps({
    widget: Object,
})

const page = reactive({
    args: {},
    dat: {},
    labels: [],
    leds: [],
})

const primary = ref(null)

function update() {
    let widget = props.widget
    Object.assign(page, getWidgetProps(widget, {primary}))
    let data = page.data.primary

    // value = [true, false, 0, false, true]
    // value = {'P1-1': 1, 'PS-2': 0, 'PS-3': 1, 'P2-4': false}
    page.labels = []
    page.leds = []
    if (data && Array.isArray(data)) {
        for (let v of data) {
            if (v) {
                v = 'on'
            } else if (v == null) {
                v = 'indeterminate'
            } else {
                v = 'off'
            }
            page.leds.push({value: v, class: v})
        }
    } else if (data && typeof data === 'object') {
        for (let [label,v] of Object.entries(data)) {
            if (v) {
                v = 'on'
            } else if (v == null) {
                v = 'indeterminate'
            } else {
                v = 'off'
            }
            page.leds.push({value: v, class: v})
            page.labels.push(label)
        }
    }
}
</script>

<template>
    <div class="led-widget" ref="primary">
        <v-row justify="space-around" class="leds" v-bind="page.args">
            <div v-for="led in page.leds" class="led" :class="led.class" />
        </v-row>
        <v-row justify="space-around" class="labels" v-bind="page.args">
            <div v-if="page.labels.length" v-for="label in page.labels" class="led-label">{{ label }}</div>
        </v-row>
    </div>
</template>

<style lang="scss" scoped>
@use 'sass:color';

.led-widget {
    align-self: center;
    width: 100%;
    margin: 0 20px;
    .leds {
        .led {
            height: 20px;
            width: 40px;
            border: 2px solid rgb(var(--v-theme-border-darken-1));
            &.on {
                background: color.adjust(rgb(22, 211, 22), $lightness: 25%);
            }
            &.off {
                background: rgb(var(--v-theme-error));
            }
            &.indeterminate {
                background: color.adjust(rgb(255, 255, 0), $lightness: 35%);
            }
        }
    }
    .labels {
        padding: 0 20px;
        text-align: center;
        text-transform: uppercase;
        .led-label {
            height: 20px;
            width: 50px;
            font-size: 0.9rem;
        }
    }
}
</style>
